import React from 'react'
import Layout from '../Layout'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

export default function rush_perks(props) {
    return (
        <>
            <SEOTAG page="Rush Perks" />
            <Layout props={props}>
                <div className="px-5 py-4 stctPgWrpr">
                    {/* <h2>FAQs</h2> */}
                    <span
                        dangerouslySetInnerHTML={{
                            __html: global.storeDetails.return_policy,
                        }}
                    ></span>
                </div>
            </Layout>
        </>
    )
}
